/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.entities.create.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.common.factory.gridState',
  'acme.view.application.entities.create.availability.controllers',
  'acme.view.application.entities.create.resourceTemplateModal.controllers'
])

.controller('EntitiesCreateController', ['$scope', '$state', '$uibModal', '$timeout', '$q', 'ApiService', 'HelpersService', 'PermissionsService', 'GridStateFactory', 'NoticeFactory', function($scope, $state, $uibModal, $timeout, $q, ApiService, HelpersService, PermissionsService, GridStateFactory, NoticeFactory) {

    $scope.entitiesCreate = {

      entity: {},
      model: {},
      profileImageUpload: [],
      assignments: [],
      departments: [],
      resourceTemplates: [],
      selectionCriteria: [],
      showModal: {},

      mode: 'create',
      isLoadingImage: false,
      profileImageUploadStatus: 'Change',

      resource: {
        name: '',
        department: '',
        image: '',
        email: '',
        phoneNumber: ''
      },

      sections: {
        profile: {
          open: true
        },
        criteria: {
          open: true
        },
        available: {
          open: true
        }
      },


      gridState: new GridStateFactory(),
      ownerGridState: new GridStateFactory(),
      templatesGridState: new GridStateFactory(),
      notice: new NoticeFactory(),

      init: function() {

        if ($state.params && $state.params.id && $state.params.type) {
          var self = this;

          this.entity = HelpersService.getEntityName($state.params.type);
          this.initData();

          if (!PermissionsService.check('ENTITY_' + this.entity.singular.toUpperCase() + '_VIEW')) {
            console.log('ENTITY_' + this.entity.singular.toUpperCase() + '_VIEW');
            $state.go('home.default', {}, { notify: true });
          }

          $scope.$emit('Application::contentTitleChange', {
            title: HelpersService.cap(self.entity.plural)
          });

          $scope.$emit('AppController::updateTitle', {
            title: HelpersService.cap(self.entity.plural)
          });

          $scope.$on('upload::done', this.onUploadDone);
          $scope.$on('upload::add', this.onUploadAdd);

        }
      },

      initData: function() {
        this.initEntity()
          .then(this.success.initData, this.error.initData);
        if (this.isEntityType('personnel')) {
          this.getDepartments();
        }
      },

      initEntity: function() {
        return ApiService.entity.detail({
          id: $state.params.id,
          type: $state.params.type
        });
      },

      isMode: function(mode) {
        return (this.mode === mode);
      },

      getTemplates: function() {
        this.templatesGridState.setPropertyValue('pageSize', '-1');
        this.templatesGridState.setPropertyValue('sortField', 'name');
        this.templatesGridState.setPropertyValue('sortDirection', 'asc');

        ApiService.resource.templates($.extend({}, { resourceCategory: HelpersService.cap($state.params.type) }, this.templatesGridState.getGridState())).then(this.success.getTemplates, this.error.getTemplates);
      },

      getDepartments: function() {
        this.gridState.setPropertyValue('pageSize', '-1');
        this.gridState.setPropertyValue('sortField', 'name');
        this.gridState.setPropertyValue('sortDirection', 'asc');

        ApiService.departments.list(this.gridState.getGridState()).then(this.success.getDepartments, this.error.getDepartments);
      },

      getAssignPermissions: function() {
        return 'ENTITY_' + this.entity.singular.toUpperCase() + '_ASSIGN';
      },

      getSchedulePermissions: function() {
        return 'ENTITY_' + this.entity.singular.toUpperCase() + '_SCHEDULE_VIEW';
      },

      getInstances: function(id) {
        this.ownerGridState.setPropertyValue('pageSize', '-1');
        this.ownerGridState.setPropertyValue('sortField', 'name');
        this.ownerGridState.setPropertyValue('sortDirection', 'asc');

        ApiService.resource.instances.ownerList($.extend({}, { ownerId: id }, this.ownerGridState.getGridState())).then(this.success.getInstances, this.error.getInstances);
      },

      getAssignments: function() {
        var i, ii,
          r = [];
        for (i=0,ii=this.assignments.length;i<ii;i++) {
          r.push(this.assignments[i].resourceTemplateName);
        }
        return r.join(', ');
      },

      getSkillLabel: function(plural, low) {

        var r = {
              plural: '',
              pluralCap: '',
              singular: '',
              singularCap: ''
            };

        if (this.entity.plural === 'personnel') {
          r.plural = 'roles';
          r.pluralCap = 'Roles';
          r.singular = 'role';
          r.singularCap = 'Role';
        }else{
          r.plural = 'types';
          r.pluralCap = 'Types';
          r.singular = 'type';
          r.singularCap = 'Type';
        }

        return r;

      },

      getProfileDetails: function() {
        var uuid = '',
          title = this.model.name;

        switch(this.entity.plural) {
          case 'facilities':
            uuid = this.model.image || '5afa7c3a-e2ea-4d73-8d53-0e0788a84076';

            this.resource.name = this.model.name;
            this.resource.department = this.model.department;
            this.resource.capacity = this.model.capacity;
            this.resource.contactId = this.model.contactId;
            this.resource.contactName = this.model.contactName;
            this.resource.contactEmail = this.model.contactEmail;
            this.resource.contactPhoneNumber = this.model.contactPhoneNumber;

            break;
          case 'equipment':
            uuid = this.model.image || '21583c37-a424-4f27-b3b6-fdc3bdb437bc';

            this.resource.name = this.model.name;
            this.resource.department = this.model.department;
            this.resource.contactId = this.model.contactId;
            this.resource.contactName = this.model.contactName;
            this.resource.contactEmail = this.model.contactEmail;
            this.resource.contactPhoneNumber = this.model.contactPhoneNumber;

            break;
          case 'personnel':
            uuid = this.model.profileImage || '09728cd8-2be9-4966-8ca3-7cfe0ef9e5c9';
            title = this.model.firstName + ' ' + this.model.lastName;

            this.resource.name = this.model.firstName + ' ' + this.model.lastName;
            this.resource.department = this.model.department;
            this.resource.email = this.model.email;
            this.resource.phoneNumber = this.model.phoneNumber;

            break;
        }

        $scope.$emit('Application::contentTitleChange', {
          title: title,
          buttonLeft: {
            label: 'Back',
            action: function () {
              window.history.go(-1);
            }
          },
          buttonRight: {
            label: 'Save Changes',
            action: function () {
              $scope.entitiesCreate.complete();
            }
          }
        });

        this.resource.image = '/v1/api/photos/' + uuid + '/PM';

      },

      getProfileImage: function() {
        return this.model.profileImage || HelpersService.getEntityEmptyImage(this.entity.plural);
      },

      showUsers: function() {

        var self = $scope.entitiesCreate;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/entities/create/modals/chooseUser.tpl.html',
          controller: 'EntitiesListAddModalController',
          resolve: {
            allowCreate: function() {
              return false;
            },

            showUsers: function() {
              return true;
            },

            entityType: function() {
              return {
                plural: 'personnel',
                singular: 'personnel'
              };
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.showModal.result.then(function (data) {

          self.setContact(data.entity);

        }, function () {
          // Do nothing
        });

      },

      showSelectedTypes: function(criteria) {

        var self = $scope.entitiesCreate,
            prune = function() {
              var i, ii;

              // Prune all empty selections
              for (i=self.selectionCriteria.length - 1,ii=0;i>=ii;i--) {
                if (!self.selectionCriteria[i].template || !self.selectionCriteria[i].template.id) {
                  self.selectionCriteria.splice(i, 1);
                }
              }

              self.currentCriteria = '';
            };

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/entities/create/modals/chooseAvailabilityTypes.tpl.html',
          controller: 'EntitiesCreateResourceTemplateModalController',
          resolve: {

            skillLabels: function() {
              return $scope.entitiesCreate.getSkillLabel();
            },

            resourceTypes: function() {
              return $scope.entitiesCreate.resourceTemplates;
            },

            selectedResourceTypes: function() {
              return [criteria.template];
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.showModal.result.then(function (selected) {

          var found;

          if (selected && selected[0] && selected[0].id) {
            found = self.findTemplate(criteria.templates, selected[0].id);
          }

          if (found) {
            criteria.template = criteria.templates[found.index];
            self.currentCriteria = criteria;
            self.updateSelectionCriteria(criteria);
            criteria.assignment = self.prepareCriteria(criteria)[0];
          }else{
            prune();
          }

        }, function () {
          prune();
        });

      },

      setContact: function(user) {
        this.model.contactName = user.name;
        this.model.contactEmail = user.email;
        this.model.contactPhoneNumber = user.phoneNumber;
        this.model.contactId = user.id;
      },

      clearContact: function() {
        this.model.contactName = null;
        this.model.contactEmail = null;
        this.model.contactPhoneNumber = null;
        this.model.contactId = null;
      },

      openSection: function(name) {
        this.sections[name].open = true;
      },

      closeSection: function(name) {
        this.sections[name].open = false;
      },

      toggleSection: function(name) {
        this.sections[name].open = !this.sections[name].open;
      },

      isSectionOpen: function(name) {
        return (this.sections[name].open);
      },

      manualAddSelectionCriteria: function(assignment) {
        this.showSelectedTypes(this.addSelectionCriteria(assignment));
      },

      addSelectionCriteria: function(assignment) {

        var i, ii,
            j, jj,
            found,
            c = {
              values: {},
              template: {},
              assignment: assignment || {},
              templates: angular.copy(this.resourceTemplates)
            };

        if (assignment && assignment.resourceTemplateId) {
          found = this.findTemplate(c.templates, assignment.resourceTemplateId);
          if (found) {
            c.template = c.templates[found.index];
          }

          for (i = 0, ii = assignment.fields.length; i < ii; i++) {
            c.values[assignment.fields[i].name] = [];
            if (c.template.fields[i].displayType.toLowerCase() === 'dropdown') {
              c.values[assignment.fields[i].name] = assignment.fields[i].values[0];
            }else {
              if (assignment.fields[i].values instanceof Array) {
                for (j = 0, jj = assignment.fields[i].values.length; j < jj; j++) {
                  c.values[assignment.fields[i].name].push(assignment.fields[i].values[j]);
                }
              }
            }
          }
        }

        this.selectionCriteria.push(c);

        return c;

      },

      removeSelectionCriteria: function(index) {
        if (this.selectionCriteria[index].assignment.id) {
          ApiService.resource.instances.remove(this.selectionCriteria[index].assignment.id).then(function (response) {
            var self = $scope.entitiesCreate;

            self.selectionCriteria.splice(index, 1);
            self.success.removeSelectionCriteria(response);
          }, this.error.removeSelectionCriteria);
        }else{
          this.selectionCriteria.splice(index, 1);
        }
      },

      updateSelectionCriteria: function(criteria) {
        criteria.values = {};
      },

      isEntityType: function(type) {
        return (this.entity.singular === type);
      },

      findTemplate: function(templates, id) {
        var i, ii,
            r = false;

        for (i=0,ii=templates.length;i<ii;i++) {
          if (templates[i].id === id) {
            r = {
              template: templates[i],
              index: i
            };
            break;
          }
        }

        return r;
      },

      findTemplateFieldValue: function(field, value) {
        var i, ii,
            r = false;

        for (i=0,ii=field.values.length;i<ii;i++) {
          if (field.values[i] === value) {
            r = {
              value: field.values[i],
              index: i
            };
            break;
          }
        }

        return r;
      },

      findCriteria: function(resourceTemplateId) {

        var i, ii,
            r = false;

        for (i = 0, ii = this.selectionCriteria.length; i < ii; i++) {
          if (this.selectionCriteria[i].template.id === resourceTemplateId) {
            r = {
              criteria: this.selectionCriteria[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      processCriteria: function() {
        var i, ii;

        for (i=0,ii=this.assignments.length;i<ii;i++) {
          this.addSelectionCriteria(this.assignments[i]);
        }

      },

      prepareCriteria: function(criteria) {

        var i, ii,
            current,
            resource,
            selectionCriteria = (criteria) ? [criteria] : this.selectionCriteria,
            r = [];

        for (i = 0, ii = selectionCriteria.length; i < ii; i++) {
          current = selectionCriteria[i];
          resource = {
            id: current.assignment.id,
            ownerId: this.model.id,
            name: this.model.name || this.model.firstName + ((this.model.firstName) ? ' ' : '') + this.model.lastName,
            resourceTemplateId: current.template.id,
            resourceTemplateName: current.template.name,
            resourceCategory: HelpersService.cap($state.params.type),
            description: current.template.description,
            fields: this.prepareCriteriaFieldValues(current.values)
          };

          if (this.isEntityType('personnel')) {

            resource.resourceUser = {
              userId: this.model.id,
              userFirstName: this.model.firstName,
              userLastName: this.model.lastName
            };
          }

          r.push(resource);
        }

        return r;

      },

      prepareCriteriaFieldValues: function(values) {

        var field = {},
            unique,
            fieldName,
            fieldValueId,
            r = [];

        for (fieldName in values) {

          if (values.hasOwnProperty(fieldName)) {

            if (!(field.hasOwnProperty(fieldName))) {
              field[fieldName] = {
                name: fieldName,
                values: []
              };
            }

            if (typeof(values[fieldName]) === 'string' ) {
              field[fieldName].values.push(values[fieldName]);
            }else if (typeof(values[fieldName]) === 'object') {
              // Covers Arrays or Objects
              for(fieldValueId in values[fieldName]) {
                if (values[fieldName].hasOwnProperty(fieldValueId) &&
                    field[fieldName].values.indexOf(values[fieldName][fieldValueId]) === -1 &&
                    values[fieldName][fieldValueId] !== false) {
                  field[fieldName].values.push(values[fieldName][fieldValueId]);
                }
              }
            }

          }

        }

        for (unique in field) {
          if (field.hasOwnProperty(unique)) {
            r.push(field[unique]);
          }
        }

        return r;

      },

      complete: function(uploadOnly) {

        this.notice.hideErrorMessages();
        this.notice.hideSuccessMessages();

        ApiService.entity.update($.extend({ type: $state.params.type }, this.model)).then(function(response) {
          var self = $scope.entitiesCreate;
          if (!uploadOnly) {
            $scope.$broadcast('EntitiesCreateController::Complete', { id: $state.params.id });
            self.completeCriteria();
          }else{
            self.success.complete(response);
          }
        }, this.error.complete);

      },

      completeCriteria: function() {

        var i, ii,
            instances,
            promises = [];

        instances = this.prepareCriteria();

        if (instances instanceof Array && instances.length) {
          for (i=0,ii=instances.length;i<ii;i++) {
            if (instances[i].id) {
              promises.push(ApiService.resource.instances.update(instances[i]));
            }else{
              promises.push(ApiService.resource.instances.create(instances[i]));
            }
          }
        }

        $q.all(promises).then(this.success.completeCriteria, this.error.completeCriteria);

      },

      success: {

        initEntity: function(response) {
          var self = $scope.entitiesCreate;

          self.model = response.data.payload;
          self.getProfileDetails();
          self.getTemplates();
        },

        initData: function(response) {
          $scope.entitiesCreate.success.initEntity(response);
        },

        getInstances: function(response) {
          var self = $scope.entitiesCreate;

          self.assignments = response.data.payload.list;
          self.processCriteria();
        },

        getDepartments: function(response) {
          $scope.entitiesCreate.departments = response.data.payload.list;
        },

        getTemplates: function(response) {
          var self = $scope.entitiesCreate;

          self.resourceTemplates = response.data.payload.list;
          self.getInstances($state.params.id);
        },

        removeSelectionCriteria: function(response) {},

        complete: function(response) {
          var self = $scope.entitiesCreate;

          self.notice.showSuccessMessages([{
            message: 'Successfully saved'
          }]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
          }, 3000);
        },

        completeCriteria: function(response) {
          var self = $scope.entitiesCreate;

          self.notice.showSuccessMessages([{
            message: 'Successfully saved'
          }]);

          $timeout(function() {
            self.notice.hideSuccessMessages();
            $timeout(function() {
              $state.go('application.entities.list', { type: $state.params.type });
            }, 300);
          }, 3000);
        },

        upload: function(response) {}
      },

      error: {
        generic: function(response) {
          var self = $scope.entitiesCreate;

          self.notice.showErrorMessages([{
            message: response.data.error
          }]);
        },
        initEntity: function(response) {},
        initData: function(response) {},
        getInstances: function(response) {},
        getDepartments: function(response) {},
        getTemplates: function(response) {},
        removeSelectionCriteria: function(response) {
          $scope.entitiesCreate.error.generic(response);
        },
        complete: function(response) {
          $scope.entitiesCreate.error.generic(response);
        },
        completeCriteria: function(response) {
          $scope.entitiesCreate.error.generic(response);
        },
        upload: function(response) {
          $scope.entitiesCreate.error.generic(response);
        }
      },

      onUploadAdd: function(e, data) {

        var self = $scope.entitiesCreate;

        self.isLoadingImage = true;
        self.profileImageUploadStatus = 'Uploading...';
        if (self.model.profileImage) {
          self.model.profileImage = '';
        }

      },

      onUploadDone: function(e, data) {

        var self = $scope.entitiesCreate;

        if (self.isEntityType('personnel')) {
          self.model.profileImage = data.file.uuid;
        }else{
          self.model.image = {
            id: data.file.uuid,
            description: data.file.originalPath,
            primary: true,
            thumbnail: data.file.thumbnailPath,
            highRes: data.file.highResPath,
            screen: data.file.screenPath,
            preview: data.file.previewPath
          };
        }

        self.profileImageUploadStatus = 'Change';
        self.isLoadingImage = false;

        $scope.$apply();

        $timeout(function() {
          self.complete(true);
        }, 0);

      }
    };

    $scope.entitiesCreate.init();

}]);